module.exports = __webpack_public_path__ + "static/thiem-gray-1b0afbdfd259b335999fa183fcbf7ad1.png";